import customFetch from '../customFetch';

const API_URL = process.env.VUE_APP_MACHETE_OPS_API;

const GET_CATALOG_URL = `${API_URL}/catalog/:catalog`;
const PUT_SKU = `${API_URL}/catalog/sku/company/:id`;
const DEL_SKU = `${API_URL}/catalog/sku/:id/company/:company`;
export default {
  async getCatalog(catalog, filter, query) {
    const response = await customFetch(GET_CATALOG_URL, {
      method: 'GET',
      params: { catalog },
      query: { filter, ...query },
    });
    const { payload } = await response.json();
    return payload;
  },

  async putSku(company, body) {
    const response = await customFetch(PUT_SKU, {
      method: 'PUT',
      body: JSON.stringify(body),
      params: { id: company },
    });
    const { payload } = await response.json();
    return payload;
  },

  async delSku(company, id) {
    const response = await customFetch(DEL_SKU, {
      method: 'DELETE',
      params: { company, id },
    });
    const { payload } = await response.json();
    return payload;
  },

};
